import { RegistrationFormData } from 'features/registration/interface/registration';
import { ActivationType, RegisterEvents, RegistrationType } from 'shared/constants/datalayer';
import { findCookieValue, formatDate, getBirthDateFormPesel, getEnvironmentDetails } from 'shared/util/utility';

export const registrationFormInitialValues = {
	email: '',
	password: '',
	regCode: '',
	regPromotion: {
		id: '',
		name: '',
	},
	allConsents: false,
	ageConsent: false,
	emailConsent: false,
	smsConsent: false,
	firstName: '',
	lastName: '',
	peselNum: '',
	peselNumNotAvailable: false,
	emailVerification: false,
	dob: '',
	country: '',
	phoneNum: '',
	smsCode: '',
	detailsAcknowledgement: false,
	selectAllConsents: false,
};

export const dataLayerEventsForRegBack = [
	RegisterEvents.REGISTRATION_1_BACK('manual'),
	RegisterEvents.REGISTRATION_2_BACK('manual'),
	RegisterEvents.REGISTRATION_3_BACK('manual'),
	RegisterEvents.REGISTRATION_4_BACK('manual'),
	RegisterEvents.REGISTRATION_5_BACK('manual'),
	RegisterEvents.REGISTRATION_6_BACK('manual'),
	RegisterEvents.REGISTRATION_7_BACK('manual'),
	RegisterEvents.REGISTRATION_8_BACK('manual'),
	RegisterEvents.REGISTRATION_9_BACK('manual'),
];

export const dataLayerEventsForRegNext = (
	activation_type: ActivationType,
	userEmail: string,
	marketing_checkbox: boolean,
	reg_scratch: boolean,
	consent_count_before: number | undefined,
	consent_count_after: number,
	consent_popup: boolean,
	registrationType: RegistrationType,
) => [
	RegisterEvents.REGISTRATION_1_FINISHED(registrationType),
	RegisterEvents.REGISTRATION_2_FINISHED(registrationType),
	RegisterEvents.REGISTRATION_3_FINISHED(userEmail, registrationType),
	RegisterEvents.REGISTRATION_4_FINISHED(registrationType),
	RegisterEvents.REGISTRATION_5_FINISHED(registrationType),
	RegisterEvents.REGISTRATION_6_FINISHED(activation_type, registrationType),
	RegisterEvents.REGISTRATION_7_FINISHED(registrationType),
	RegisterEvents.REGISTRATION_8_FINISHED(registrationType),
	RegisterEvents.REGISTRATION_9_FINISHED(
		activation_type,
		marketing_checkbox,
		reg_scratch,
		consent_count_before,
		consent_count_after,
		consent_popup,
		registrationType,
	),
	RegisterEvents.REGISTRATION_MARKETING_CONSENTS(marketing_checkbox, registrationType),
];

export const getRegistrationPayloadData = (data: RegistrationFormData) => {
	const { channel, browser, device } = getEnvironmentDetails();

	const dateOfBirth = !data.peselNumNotAvailable || data.dob === '' ? getBirthDateFormPesel(data.peselNum) : formatDate(data.dob, 'YYYY-MM-DD');

	const consents = [
		{ container: 'OFFERS', accepted: data.allConsents || data.selectAllConsents },
		{ container: 'REGULATIONS', accepted: true },
		{ container: 'EMAIL', accepted: data.emailConsent || data.allConsents },
		{ container: 'SMS', accepted: data.smsConsent || data.allConsents },
	];

	return {
		firstName: data.firstName,
		lastName: data.lastName,
		loginName: data.email,
		password: data.password,
		email: data.email,
		mobile: data.phoneNum,
		bonus: data.allConsents || data.selectAllConsents || false,
		verificationCode: data.smsCode,
		receiveEmail: data.emailConsent || data.allConsents || data.selectAllConsents || false,
		receiveSms: data.smsConsent || data.allConsents || data.selectAllConsents || false,
		channel,
		browser,
		device,
		registrationOffers: data.regCode ? [data.regCode] : [],
		clickId: findCookieValue('__utmzz') || '1',
		nationality: data.peselNumNotAvailable ? data.country : 'PL',
		personalIdentificationNumber: data.peselNum,
		dateOfBirth,
		consents,
		affiliateCode: findCookieValue('affiliateCode'),
		promotion: data.regPromotion,
	};
};

export const getMaxDateForRegistration = () => {
	const d = new Date();
	return new Date(d.getFullYear() - 18, d.getMonth(), d.getDate() - 1).getTime();
};

export const EMAIL_DOMAINS = [
	'gmail.com',
	'wp.pl',
	'o2.pl',
	'interia.pl',
	'onet.pl',
	'op.pl',
	'icloud.com',
	'vp.pl',
	'poczta.fm',
	'tlen.pl',
	'onet.eu',
	'interia.eu',
	'poczta.onet.pl',
	'outlook.com',
	'spoko.pl',
	'hotmail.com',
	'yahoo.com',
	'int.pl',
	'mail.ru',
	'gazeta.pl',
	'protonmail.com',
	'onet.com.pl',
	'opoczta.pl',
	'autograf.pl',
	'buziaczek.pl',
	'interia.com',
	'vip.onet.pl',
	'ukr.net',
	'amorki.pl',
	'go2.pl',
	'pisz.to',
	'yahoo.pl',
	'poczta.onet.eu',
	'adres.pl',
	'pacz.to',
	'googlemail.com',
	'intmail.pl',
	'yahoo.co.uk',
	'me.com',
];
